module.exports = __webpack_public_path__ + "img/stars.2b73ccaa.svg";